import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { isCarReserved } from '@upstart/harmony/lib/car-utils';
import { CarStatus, Condition } from '@upstart/harmony/lib/constants';
import Img from 'react-image';
import ReactLoading from 'react-loading';
import imageFalback from './no-photo.png';
import './CarImage.scss';

export default function CarImage({ car, style, className, dealer }) {
  let overlayText;
  if (car?.status === CarStatus.SALE_PENDING) {
    overlayText = 'Sale Pending';
  } else if (isCarReserved(car)) {
    overlayText = 'Reserved';
  }
  const showInTransitTag = car?.inTransit;
  const showCertifiedTag =
    dealer?.featureConfig?.useCPO?.enabled && car?.condition === Condition.CPO;
  return (
    <div
      className={classNames(
        'car-image-container',
        overlayText && 'withOverlay',
        style,
        className,
      )}
    >
      <Img
        src={[car.carImg, car.dealerImg]}
        className="car-image"
        unloader={
          <img src={imageFalback} alt={car.name} className="car-image" />
        }
        loader={
          // Show loading animation while fetching image
          <ReactLoading type="bubbles" height="30%" width="30%" color="blue" />
        }
      />
      {overlayText && (
        <div className="car-image-overlay imageOverlay">{overlayText}</div>
      )}
      <div className="car-image-opaque-overlay">
        {showInTransitTag && (
          <div className="car-in-transit-label">In Transit</div>
        )}
        {showCertifiedTag && (
          <div className="car-certified-label">Certified</div>
        )}
      </div>
    </div>
  );
}

CarImage.propTypes = {
  car: PropTypes.object,
  style: PropTypes.object,
  className: PropTypes.string,
  dealer: PropTypes.object,
};

CarImage.defaultProps = {
  car: {},
};
